<template>
    <div class="product__list">
        <div class="product" v-for="item in products" :key="item.sku" :style="getProductStyle()">
            <div class="top">
                <div class="params">
                    <div class="item" v-if="item.category">{{ item.category }}</div>
                    <div class="item" v-if="item.year">{{ item.year }}</div>
                </div>
                <div class="image">
                    <div class="badges">
                        <div class="badge sold" v-if="item.sold">Sold</div>
                        <div class="badge" v-else-if="item.alert" :style="{ background: item.alert.color || 'rgb(255, 183, 16)' }">{{ item.alert.text }}</div>
                    </div>
                    <SliderImage v-if="item.images.length > 0" :images="item.images"></SliderImage>
                    <div class="no-image" v-else><span>No photo</span></div>
                </div>
                <div class="title">{{ item.title }}</div>
                <div class="model__wrapper">
                    <div class="model" v-if="item.make">{{ item.make }}</div>
                    <div class="price">{{ formatPrice(item.price) }}</div>
                </div>
            </div>
            <div class="bottom">
                <a href="">
                    Learn More
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.99 9.37L12.05 5.44L12.94 4.55L17.94 9.55L18.38 9.99L17.94 10.44L12.94 15.44L12.05 14.55L15.99 10.62L2.5 10.62L2.5 9.37L15.99 9.37Z" fill="#050505" fill-rule="evenodd"/>
                    </svg>
                </a>
            </div>
            <router-link :to="{ name: 'ugm-machine', params: { slug: item.sku } }"></router-link>
        </div>
    </div>
</template>

<script>
import SliderImage from '../Products/SliderImage.vue';
import { formatPrice } from './price';
export default {
    components: {
        SliderImage,
    },
    props: {
        products: {
            type: Array,
            required: true,
        },
        itemsPerRow: {
            type: Number,
            default: 3,
        },
        gap: {
            type: Number,
            default: 32,
        },
    },
    methods: {
        formatPrice,
        getProductStyle() {
            const totalGapWidth = ((this.itemsPerRow - 1) * this.gap) / this.itemsPerRow;
            return {
                width: `calc(${100 / this.itemsPerRow}% - ${totalGapWidth}px)`,
            };
        },
    },
}
</script>

<style scoped>
.product > a{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
}
.bottom{
    background: rgb(255, 255, 255);
    height: 56px;
}
.bottom a{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 100%;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
}
.model__wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
.model__wrapper .model{
    display: flex;
    align-items: center;
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    height: 26px;
    border-radius: 81px;
    background: rgb(255, 255, 255);
    padding: 0 8px;
    max-width: 60%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.model__wrapper .price{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    white-space: nowrap;
}
.params{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-bottom: 14px;
}
.params .item{
    display: flex;
    align-items: center;
    height: 26px;
    padding: 0 8px;
    border-radius: 81px;
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    background: rgb(255, 255, 255);
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.image{
    position: relative;
}
.badges{
    position: absolute;
    top: 12px;
    left: 12px;
    right: 12px;
    z-index: 3;
    display: flex;
    pointer-events: none;
}
.badge{
    padding: 4px 10px;
    border-radius: 81px;
    color: rgb(255, 255, 255);
    font-size: 12px;
    font-weight: 500;
    line-height: 140%;
    text-transform: uppercase;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.badge.sold{
    background: rgb(5, 5, 5);
}
.no-image{
    position: relative;
    padding-top: 82%;
    background: rgb(255, 255, 255);
    margin-bottom: 20px;
}
.no-image span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
}
.product__list{
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
}
.top{
    padding: 19px 16px 12px 16px;
}
.product__list .product{
    background: rgb(222, 230, 234);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.product .title{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    padding: 16px 0;
}
@media (max-width: 1320px) {
    .product__list .product{
        width: calc((100% / 2) - 16px) !important;
    }
}
@media (max-width: 768px) {
    .product__list .product{
        width: 100% !important;
    }
    .product .title{
        font-size: 20px;
    }
}
</style>
